import { useLocation } from "preact-iso";
import { Reveal } from "./Reveal";
import { gateway } from "../content/wedding";

/**
 * The rest of the site, at the foot of the page you are on.
 *
 * With the invitation split across four addresses, the end of a page is
 * exactly where a guest wants the next one, and the alternative is sending
 * them back to the front door to find it. The rows are the landing page's own
 * cards with wherever they already are taken out, so there is one list of
 * pages in the content file and no second copy to keep in step.
 */
export function PageLinks() {
  const { path } = useLocation();
  const rest = gateway.filter((card) => card.href !== path);

  return (
    <section class="section pagelinks">
      <div class="shell shell--reading">
        <Reveal class="pagelinks__head">
          <span class="eyebrow">More Information</span>
        </Reveal>
        <div class="index">
          {rest.map((card, i) => (
            <Reveal key={card.href} delay={i * 70}>
              <a class="index__row" href={card.href}>
                <span class="index__label">{card.title}</span>
                <span class="index__detail">{card.kicker}</span>
                <span class="index__arrow" aria-hidden="true">
                  &rarr;
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
